export default "__VITE_ASSET__DF$jpUws__"